import Disabled from './Disabled';

export default Disabled;
